// :cow: Cosmose CONFIDENTIAL :iso:
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardLocationPreferencesComponent } from './components/dashboard-location-preferences/dashboard-location-preferences.component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { dashboardLocationPreferencesReducer, STATE_NAME } from './store/dashboard-location-preferences.reducer';
import { DashboardLocationPreferencesEffects } from './store/dashboard-location-preferences.effects';
import { TranslateModule } from '@ngx-translate/core';
import { DashboardLocationPreferencesSkeletonComponent } from './components/dashboard-location-preferences/dashboard-location-preferences-body/dashboard-location-preferences-skeleton/dashboard-location-preferences-skeleton.component';
import { DashboardLocationPreferencesListElementComponent } from './components/dashboard-location-preferences/dashboard-location-preferences-body/dashboard-location-preferences-list-element/dashboard-location-preferences-list-element.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SankeyPipe } from './pipes/sankey.pipe';
import { DashboardLocationPreferencesSelectLocationComponent } from './components/dashboard-location-preferences/dashboard-location-preferences-header/dashboard-location-preferences-select-location/dashboard-location-preferences-select-location.component';
import { SankeyDiagramModule } from '@coa/app/shared/sankey-diagram/sankey-diagram.module';
import { ListModule } from '@coa/app/shared/list/list.module';
import { DashboardLocationPreferencesListComponent } from './components/dashboard-location-preferences/dashboard-location-preferences-body/dashboard-location-preferences-list/dashboard-location-preferences-list.component';
import { DashboardLocationPreferencesEmptyComponent } from './components/dashboard-location-preferences/dashboard-location-preferences-body/dashboard-location-preferences-empty/dashboard-location-preferences-empty.component';
import { DashboardLocationPreferencesErrorComponent } from './components/dashboard-location-preferences/dashboard-location-preferences-body/dashboard-location-preferences-error/dashboard-location-preferences-error.component';
import { DashboardLocationPreferencesChartComponent } from './components/dashboard-location-preferences/dashboard-location-preferences-body/dashboard-location-preferences-chart/dashboard-location-preferences-chart.component';
import { DashboardLocationPreferencesHeaderComponent } from './components/dashboard-location-preferences/dashboard-location-preferences-header/dashboard-location-preferences-header.component';
import { DashboardLocationPreferencesBodyComponent } from './components/dashboard-location-preferences/dashboard-location-preferences-body/dashboard-location-preferences-body.component';

@NgModule({
  declarations: [
    DashboardLocationPreferencesComponent,
    DashboardLocationPreferencesSkeletonComponent,
    DashboardLocationPreferencesListElementComponent,
    SankeyPipe,
    DashboardLocationPreferencesSelectLocationComponent,
    DashboardLocationPreferencesListComponent,
    DashboardLocationPreferencesEmptyComponent,
    DashboardLocationPreferencesErrorComponent,
    DashboardLocationPreferencesChartComponent,
    DashboardLocationPreferencesHeaderComponent,
    DashboardLocationPreferencesBodyComponent,
  ],
  imports: [
    CommonModule,
    StoreModule.forFeature(STATE_NAME, dashboardLocationPreferencesReducer),
    EffectsModule.forFeature([DashboardLocationPreferencesEffects]),
    TranslateModule.forChild(),
    SankeyDiagramModule,
    MatFormFieldModule,
    MatSelectModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    ListModule,
  ],
  exports: [
    DashboardLocationPreferencesComponent,
  ],
})
export class DashboardLocationPreferencesModule {
}
